module.exports = "\r\n<section class=\"pt-5 alert-section\">\r\n<div *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} alert-dismissable\">\r\n  {{alert.message}}\r\n  <a class=\"close-btn\" (click)=\"removeAlert(alert)\">&times;</a>\r\n</div>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/app/alert/alert.component.html
// module id = ../../../../../src/app/alert/alert.component.html
// module chunks = main